export const PROFILE_SPECIALCASES_FETCH = 'PROFILE_SPECIALCASES_FETCH';
export const PROFILE_SPECIALCASES_IS_FETCING = 'PROFILE_SPECIALCASES_IS_FETCING';
export const PROFILE_SPECIALCASES_API = 'profiles';
export const PROFILE_SPECIALCASE_EDIT = 'PROFILE_SPECIALCASE_EDIT';
export const PROFILE_SPECIALCASE_SAVE = 'PROFILE_SPECIALCASE_SAVE';


// WEBPACK FOOTER //
// ./src/constants/profileSpecialCases.js